
import { onUnmounted, reactive, toRefs } from "vue";
import {
  clearAuthToken,
  setTimeZone,
  getUserTimeZone,
  setLanguage,
  getLanguage,
  getTheme,
  setTheme,
  getSelectedPages,
  updateSelectedPages,
  getEditNavBar,
  setEditNavBar,
  getMaxBurstsSelectable,
  setMaxBurstsSelectable,
} from "@/helpers/store";
import { listTimeZones } from "timezone-support";
import { Temporal } from "@js-temporal/polyfill";

export default {
  name: "SettingsPage",
  setup() {
    const state = reactive({
      selectedTimezone: getUserTimeZone(),
      selectedLanguage: getLanguage(),
      selectedTheme: getTheme(),
      timezones: listTimeZones().filter((zone) => {
        if (!zone.includes("Etc/G")) return zone;
      }),
      currentTime: "",
      selectedPages: {},
      editNavBar: getEditNavBar(),
      maxBurstsSelectable: getMaxBurstsSelectable(),
    });

    state.selectedPages = getSelectedPages();

    const updateCurrentTime = () => {
      state.currentTime = Temporal.Now.zonedDateTimeISO(state.selectedTimezone).toLocaleString(state.selectedLanguage);
    };

    updateCurrentTime();

    const interval = setInterval(() => {
      updateCurrentTime();
    }, 1000);

    onUnmounted(() => {
      clearInterval(interval);
      setEditNavBar(false);
    });

    return {
      ...toRefs(state),
      setLanguage,
      setTimeZone,
      setTheme,
      updateSelectedPages,
      setEditNavBar,
      getMaxBurstsSelectable,
      setMaxBurstsSelectable,
    };
  },
  methods: {
    logout() {
      clearAuthToken();
      window.location.assign("/login");
    },
  },
};
